import { render } from "./member-set.vue?vue&type=template&id=4a22538f&scoped=true&ts=true"
import script from "./member-set.vue?vue&type=script&lang=ts"
export * from "./member-set.vue?vue&type=script&lang=ts"

import "./member-set.vue?vue&type=style&index=0&id=4a22538f&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a22538f"]])

export default __exports__